import { StyleSheet } from 'aphrodite/no-important';
import { colour } from '../style/base-theme';

export const styles = StyleSheet.create({
  container: {
    textDecoration: 'none',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    flexBasis: 70,
    flexGrow: 0,
    marginRight: 5,
    marginBottom: 10
  },
  title: {
    fontSize: 14,
    fontWeight: 600,
    color: colour.grey[200],
    display: 'block',
    textAlign: 'center',
    marginTop: 5,
    width: '100%'
  },
  onHightlight: {
    color: '#FFFFFF',
    background: colour.brand.green,
    borderRadius: 10,
    padding: '0px 5px 1px',
    fontSize: 12,
    fontWeight: 600,
    marginTop: 5,
    textAlign: 'center'
  }
});
